import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingOther: false,
  isChecking: false,
  isValidating: false,
  isVerifying: false,
  isFetchingName: false,
  isFetchingRMIProvKeyId: false,
  isFetchingNameAndId: false,

  result: [],
};

const claimNPIReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_PROVIDER_NPI_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_PROVIDER_NPI_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_PROVIDER_NPI_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };


    case types.GET_OTHER_PROVIDER_NPI_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingOther: true,
      };

    case types.GET_OTHER_PROVIDER_NPI_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingOther: false,
      };

    case types.GET_OTHER_PROVIDER_NPI_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingOther: false,
      };

    case types.CHECK_IS_DME_REQUEST:
      return {
        ...state,
        result: [],
        isChecking: true,
      };

    case types.CHECK_IS_DME_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isChecking: false,
      };

    case types.CHECK_IS_DME_FAILURE:
      return {
        ...state,
        result: [],
        isChecking: false,
      };

    case types.VALIDATE_RENDERING_NPI_REQUEST:
      return {
        ...state,
        result: [],
        isValidating: true,
      };

    case types.VALIDATE_RENDERING_NPI_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isValidating: false,
      };

    case types.VALIDATE_RENDERING_NPI_FAILURE:
      return {
        ...state,
        result: [],
        isValidating: false,
      };

    case types.VERIFY_NPI_REQUEST:
      return {
        ...state,
        result: [],
        isVerifying: true,
      };

    case types.VERIFY_NPI_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isVerifying: false,
      };

    case types.VERIFY_NPI_FAILURE:
      return {
        ...state,
        result: [],
        isVerifying: false,
      };

    case types.GET_NAME_FROM_NPI_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingName: true,
      };

    case types.GET_NAME_FROM_NPI_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingName: false,
      };

    case types.GET_NAME_FROM_NPI_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingName: false,
      };

    case types.GET_RMIPROVKEYID_FROM_NPI_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingRMIProvKeyId: true,
      };

    case types.GET_RMIPROVKEYID_FROM_NPI_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingRMIProvKeyId: false,
      };

    case types.GET_RMIPROVKEYID_FROM_NPI_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingRMIProvKeyId: false,
      };

    case types.GET_NAME_AND_ID_FROM_RMIPROVKEYID_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingNameAndId: true,
      };

    case types.GET_NAME_AND_ID_FROM_RMIPROVKEYID_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingNameAndId: false,
      };

    case types.GET_NAME_AND_ID_FROM_RMIPROVKEYID_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingNameAndId: false,
      };

    case types.CANCEL_CLAIM_REQUEST:
      return {
        ...state,
        result: action.payload,
        isCanceling: true,
      };

    case types.CANCEL_CLAIM_SUCCESS:
      return {
        ...state,
        result: [],
        isCanceling: false,
      };

    case types.CANCEL_CLAIM_FAILURE:
      return {
        ...state,
        result: [],
        isCanceling: false,
      };

    case types.POST_CLAIM_HISTORY_REQUEST:
      return {
        ...state,
        result: action.payload,
        isPostingHistory: false,
      };

    case types.POST_CLAIM_HISTORY_SUCCESS:
      return {
        ...state,
        result: [],
        isPostingHistory: false,
      };

    case types.POST_CLAIM_HISTORY_FAILURE:
      return {
        ...state,
        result: [],
        isPostingHistory: true,
      };


    default:
      return state;
    }
};

export default claimNPIReducer;
